<template>
<div>
  <div class="page">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="left">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{this.$route.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="right">
            <input type="text"  class="search" placeholder="请输入关键字"  v-model="input" @input="inputlist()">
            <img src="../../assets/img/search.png" class="searchImg" alt="搜索" >
            <div class="searchlist" v-if="searchliststatus">
                <ul>
                  <li style="color:rgba(0, 103, 255, 1)">指标：</li>
                  <li  v-for="(item,index) in searchlistzb"
                        :key="index"
                        @click="searchcheck(item,index)"
                    >
                      {{item.resName}}
                    </li>
                    <li style="color:rgba(0, 103, 255, 1)">文章：</li>
                  <li  v-for="(item,index) in searchlistwz"
                        :key="index"
                        @click="wzlistcheck(item)"
                    >
                      {{item.resName}}
                    </li>
                </ul>
             </div>
        </div>
      </div>
      <div class="dataQuery">
        <div class="menu">
        <div class="firstMenu">
            <a @click="getMenu('jdsj',true)" style="margin-left:50px"><span :class="{ tabOn: isActive }">报表数据</span></a>
        </div>
        <div style="width:100%;height:2px;background: #fff;"></div>
        <!-- <hc-tree :dataList="dataList"></hc-tree> -->
        <el-scrollbar style="height:1155px">
            <el-menu :default-active="defaultIndex" class="el-menu-vertical-demo secondMenu"  @select="handleSelect"> 
                <template v-for="(item, index) in menuList" :index = "index">
                    <el-submenu :index="index" :key ="item.name">
                        <template slot="title">
                            <i :class="['iconfont', item.icon]"></i>
                            <span slot="title" class="">{{item.itemName}}</span>
                        </template>
                        <template v-for="child in item.childIndicator">
                            <el-tooltip v-if="child.resName.length>8" :content="child.resName" placement="top" :key="child.pubResourceId">
                                <el-menu-item :index="child.pubResourceId" :key="child.pubResourceId" :label="child.resName" class="hoverStyle" @click="getreportlist(child)">{{child.resName}}</el-menu-item>
                            </el-tooltip>
                            <el-menu-item v-else :index="child.pubResourceId" :key="child.pubResourceId" :label="child.resName" class="hoverStyle" @click="getreportlit(child)">{{child.resName}}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <!-- <template v-for="item in menuListS">
                    <el-tooltip v-if="item.resName.length>10" :content="item.resName" placement="top" :key="item.pubResourceId">
                        <el-menu-item :index="item.pubResourceId" :key ="item.pubResourceId" :label="item.resName" @click="getData(item)">{{item.resName}}</el-menu-item>
                    </el-tooltip>
                    <el-menu-item v-else :index="item.pubResourceId" :key ="item.pubResourceId" :label="item.resName" @click="getData(item)">{{item.resName}}</el-menu-item>
                </template> -->
            </el-menu>
        </el-scrollbar>
        </div>
        <div class="charts">
        <el-breadcrumb separator="/" class="indicatorBreadcrumb">
            <template v-for="(item,index) in breadcrumbList">
                <el-breadcrumb-item :key="index">{{ item }}</el-breadcrumb-item>
            </template>
        </el-breadcrumb>
        <div v-if="reportshow" class="">
            <design v-if="report_show" :report_id="report_id" :report_name="report_name" ref="design"></design>
        </div>
       <div v-else class="report-list" >
           <ul>
                  <li  v-for="(item,index) in reportlist"
                        :key="index"
                        >
                        <a @click="listcheck(item,index)">{{item.name}}</a>
                        <span>{{item.startDate}}</span>
                 </li>
                 <div class="num-style">
                     <span v-for="(item,index) in num"
                        :key="index"
                        @click="numcheck(itemtype,index+1)">
                        {{index+1}}</span>
                 </div>
              </ul>
       </div>
        
        </div>
      </div>
  </div>
  <div class="foot">
    <span>郴州市统计局</span>
    <span>技术支持：浙江鸿程计算机系统有限公司</span>
  </div>
</div>
</template>

<script>
import HcTable from '@/components/table.vue'
import echarts from "echarts";
import design from "@/components/handsontable/design.vue";
import { getReportlist,getpdlist,getReport  } from '@/api/dataReport.js'
import {searchdata} from '@/api/index.js'
import quarterSelect from '@/components/quarterSelect.vue';
// import HcTree from '@/components/tree.vue';
export default {
    components: {
        HcTable, quarterSelect,design
    },
    data() {
        return {
            report_id: '',
            report_name: '',
            report_show: false,
            dataList: [],
            isActive: true,
            reportshow: false,
            keywords: '', // 搜索
            menuList: [], // 有父级元素的指标
            menuListS: [], // 直接指标
            options: [
                {name: '按地区查询', value: '2'},
                {name: '按时间查询', value: '1'}
            ],
            option: '1',
            // 月
            startDate: '',
            endDate: '',
            starttime: '',
            endtime: '',
            title: '',
            num:[],
            itemtype:'',
            reportlist:'',
            // chooseDate: '',
            dateType: true, //true表示按月来查
            tableData: [],
            chartData: [],
            xdata: [],
            chartType: [],
            result: null,
            selectMenu: {},
            description: '',
            unit: [],
            input:'',
            searchlistzb:'',
            searchlistwz:'',
            searchliststatus:false,
            searchliststatusnone:false,
            indicatorBreadcrumb: [],
            defaultIndex: '',
            breadcrumbList: [],
            quarterVS: '',
            quarterVE: '',
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.getMenu('jdsj', true, this.$store.state.indicatorId)
            return
        }
        if (!this.$route.query.type) {
            this.getMenu('jdsj', true)
        } else if (this.$route.query.type === 1) {
            this.getMenu('ndsj', false)
        } else if (this.$route.query.type === 2) {
            this.getMenu('jdsj', false)
        }
    },
    methods: {
        /* 根据指标对象item在当前active下的menuLst中查找对应的menu，如果没找到，切换active状态，继续查找，如果未找到提示当前指标不存在。
         *  如果找到了就获取指标数据
         */
        searchcheck(item,index){
        this.$store.commit('getindicatordata',item);
        this.$router.push({path:'/dataQuery',query:{type: 2}});
    },
        // 为tree提供data
        assembleData(data) {
            let _this = this;
            let dataList = [];
            let node = {};
            if (!data) {
                return []
            }
            if (data.childPubItem) {
                for (let i of data.childPubItem) {
                    node = {}
                    node.label = i.itemName
                    node.id = i.id
                    node.children = _this.assembleData(i)
                    dataList.push(node)
                }
            }
            if (data.childIndicator) {
                for (let t of data.childIndicator) {
                    node = {}
                    node.label = t.resName
                    node.id = t.resourceId
                    node.areaId = t.areaId
                    node.pd = t.pd
                    node.pubResourceId = t.pubResourceId
                    node.children = []
                    dataList.push(node)
                }
            } 
            return dataList;
        },
        // 根据指标对象，在当前active对应的菜单中，找到相应的menu
        chooseIndicator(item) {
            let _this = this;
            let check = false;
            _this.breadcrumbList = [];
            _this.indicatorBreadcrumb = [];
            for (let i=0;i<_this.menuListS.length;i++) { // 在外层指标中
                if (_this.menuListS[i].pubResourceId == item.pubResourceId) {
                    check = true;
                    _this.defaultIndex = item.pubResourceId;
                    _this.dateType = item.pd;
                    _this.indicatorBreadcrumb.push(item.resName);
                    break;
                }
            }
            if (!check) {
                // outer: 
                for (let t=0;t<_this.menuList.length;t++) { // 在内层指标中
                // inner: 
                    for (let j=0;j<_this.menuList[t].childIndicator.length;j++) {
                        if (_this.menuList[t].childIndicator[j].pubResourceId == item.pubResourceId) {
                            _this.defaultIndex = item.pubResourceId;
                            _this.dateType = item.pd;
                            _this.indicatorBreadcrumb.push(_this.menuList[t].itemName);
                            _this.indicatorBreadcrumb.push(_this.menuList[t].childIndicator[j].resName);
                            check = true;
                            break;
                        }
                    }
                }
            }
            let breadcrumb = _this.isActive ?  '报表数据' : '报表数据';
            _this.breadcrumbList.push(breadcrumb);
            _this.breadcrumbList = _this.breadcrumbList.concat(_this.indicatorBreadcrumb);
            return check;
        },
        changeMS(date) {
            this.starttime = date.substr(0,4)+date.substr(5,2);
        },
        changeME(date) {
            this.endtime = date.substr(0,4)+date.substr(5,2);
        },
        changeYS(date) {
            this.starttime = date+'12';
        },
        changeYE(date) {
            this.endtime = date+'12';
        },
        quarterValue(data){
            this.starttime = data;
        },
        quarterValueS(data){
            this.endtime = data;
        },
        // 点击左侧菜单与面包屑的关联
        handleSelect(key, index, name) {
            // 根据index查询name
            let _this = this;
            _this.indicatorBreadcrumb = [];
            _this.breadcrumbList = [];
            let breadcrumb = _this.isActive ?  '报表数据' : '报表数据';
            _this.breadcrumbList.push(breadcrumb);
            if (index.length == 1) {
                
                _this.indicatorBreadcrumb.push(name.$attrs.label);
                _this.breadcrumbList = _this.breadcrumbList.concat(_this.indicatorBreadcrumb);
            } else if (index.length == 2) {
                
                _this.menuList.forEach(t=>{
                    if (index[0] == t.id) {
                        _this.indicatorBreadcrumb.push(t.itemName);
                        for(let j=0;j<t.childIndicator.length;j++) {
                            if (t.childIndicator[j].pubResourceId == index[1]) {
                                _this.indicatorBreadcrumb.push(t.childIndicator[j].resName);
                                _this.breadcrumbList = _this.breadcrumbList.concat(_this.indicatorBreadcrumb);
                                break;
                            }
                        }
                    }
                })
            }
        },
        inputlist(){
           if(this.input==''){
                this.searchliststatus=false
            }
            else{
                this.searchliststatus=true
                searchdata({resourceName:this.input,resourceType:'1'})
                .then(res=>{
                    
                    this.searchlistzb=res.data.data
                })
                searchdata({resourceName:this.input,resourceType:'2'})
                .then(res=>{
                
                    this.searchlistwz=res.data.data
                })
            }
        },
        wzlistcheck(item){
           this.$router.push({ path:'/article',query:{id:item.resoruceId,}}); 
        },
        // 左侧菜单
        getMenu (item, flag, id) {
            let _this = this;
            _this.isActive = item == 'jdsj' ? true : false;
            _this.breadcrumbList = [];
            _this.indicatorBreadcrumb = [];
            getReportlist({

            })
            .then(res=>{
                // _this.dataList = _this.assembleData(res.data.data);
                console.log(res.data.data.childPubItem)
                
                _this.menuList = res.data.data.childPubItem ? res.data.data.childPubItem : []
                _this.menuListS = res.data.data.childIndicator ? res.data.data.childIndicator : []
                if (!flag) {
                    _this.selectMenu = this.$store.state.indicatordata;
                    if (_this.selectMenu) {
                        _this.searchcheck1(_this.selectMenu);
                        return;
                    }
                }
                if (id) {
                    let indicator = _this.filterIndicator(id)
                    if (!indicator && item === 'jdsj') {
                        _this.getMenu('ndsj', true, id)
                        return
                    } else if (!indicator && item === 'ndsj') {
                        _this.$alert('该指标数据不在当前指标树中', '提示', {confirmButtonText: '确定'});
                        return
                    } else {
                        _this.searchcheck1(indicator)
                        return
                    }
                }
                if (_this.menuList.length > 0 && _this.menuList[0].childIndicator.length > 0) {
                    
                    _this.selectMenu = _this.menuList[0].childIndicator[0];
                    _this.defaultIndex = _this.selectMenu.pubResourceId;
                    _this.dateType = _this.selectMenu.pd; 
                    _this.indicatorBreadcrumb.push(_this.menuList[0].itemName);
                    _this.indicatorBreadcrumb.push(_this.menuList[0].childIndicator[0].resName);
                    console.log(_this.indicatorBreadcrumb)
                } else if (_this.menuListS.length > 0) {
                    _this.selectMenu = _this.menuListS[0];
                    _this.defaultIndex = _this.selectMenu.pubResourceId;
                    _this.dateType = _this.selectMenu.pd; 
                    _this.indicatorBreadcrumb.push(_this.menuListS[0].resName);
                } else {
                    _this.$alert('指标数据为空', '提示', {confirmButtonText: '确定'});
                }
                let breadcrumb = _this.isActive ?  '报表数据' : '年度数据';
                _this.breadcrumbList.push(breadcrumb);
                _this.breadcrumbList = _this.breadcrumbList.concat(_this.indicatorBreadcrumb);
                this.getreportlist(_this.menuList[0].childIndicator[0])
                //this.getTime();
                //this.getData(false);
            });
        },
        // 根据id在当前菜单中找到对应的指标菜单
        filterIndicator (id) {
            let _this = this
            let filterIndic = []
            filterIndic = _this.menuListS.filter(t => t.pubResourceId === id)
            if (filterIndic.length > 0) {
                return filterIndic[0]
            } else {
                let a = []
                for (let i = 0; i < _this.menuList.length; i++) {
                    // for (let j = 0; j < _this.menuList[i].childIndicator.length; j++) {
                        a = _this.menuList[i].childIndicator.filter(m => m.pubResourceId === id)
                        if (a.length > 0) {
                            return a[0]
                        }
                    // }
                     
                }
                return false
            }
        },
        // 日期组件的默认值设置
        getTime(){
            let _this = this;
            let date = new Date();
            let y = date.getFullYear();
            let m = date.getMonth(); 
            if (_this.dateType == '1') { // 月度
                if (m == '12') {
                    _this.startDate = y +'年'+'01月';  
                    m = m < 10 ? ('0' + m) : m;
                    _this.endDate = y+'年'+m+'月';
                    _this.starttime = y+'01';
                    _this.endtime = y+''+m;
                } else {
                    let mS = m+1 < 10 ? ('0' + (m+1)) : m+1;
                    _this.startDate = y-1 +'年'+mS+'月'; 
                    m = m < 10 ? ('0' + m) : m;
                    _this.endDate = y+'年'+m+'月';
                    _this.starttime = y-1 +''+mS;
                    _this.endtime = y+''+m;
                }
            } else if (_this.dateType == '2') { // 季度
                if (m < 3) {
                    _this.quarterVE = y-1+'10-'+(y-1)+'12';
                    _this.quarterVS = y-1+'01-'+(y-1)+'03';
                    _this.endtime = y-1+'12';
                    _this.starttime = y-1+'03';
                } else if (m < 6) {
                    _this.quarterVE = y+'01-'+y+'03';
                    _this.quarterVS = y-1+'04-'+(y-1)+'06';
                    _this.endtime = y+'03';
                    _this.starttime = y-1+'06';
                } else if (m < 9) {
                    _this.quarterVE = y+'04-'+y+'06';
                    _this.quarterVS = y-1+'07-'+(y-1)+'09';
                    _this.endtime = y+'06';
                    _this.starttime = y-1+'09';
                } else {
                    _this.quarterVE = y+'07-'+y+'09';
                    _this.quarterVS = y-1+'10-'+(y-1)+'12';
                    _this.endtime = y+'09';
                    _this.starttime = y-1+'12';
                }
            } else if (_this.dateType == '3') { // 年度
                _this.endDate = y-1+'';
                _this.startDate = y-5+''; 
                _this.starttime = _this.startDate + '12';
                _this.endtime = _this.endDate + '12';
            }
        },
        // 获取报表列表
        getreportlist(item){
            this.reportshow = false
            getpdlist({
                id: item.id,
                page: '1',
                pagesize:'10' 
            })
            .then(res=>{
                this.num=[],
                this.itemtype = item.id,
                  this.reportlist = res.data.data.list
                  for(var i=1;i<res.data.data.totalNum/10+1;i++){
                      this.num.push(i)
                  }
                
            })
        },
        // 页码点击事件
        numcheck(itemtype,num){
          getpdlist({id:itemtype,page:num,pagesize:'10'})
              .then(res=>{
                  this.reportlist=res.data.data.list
              })
      },
      // 获取报表详情
      listcheck(item){
          this.$router.push({ path:'/reportdetail',query:{id:item.id,}}); 
      },
        // 
        renderChart(d) {
            let data = [];
            // this.renderChart = false;
            let legend = [];
            for (let i in d) {
                this.xdata = d[i].xdata;
                data.push(d[i]);
                legend.push(d[i].legend);
            }
            this.chartData = data;
            this.legend = legend;
            this.draw();
        },
        // 制作图表
        draw() {
            // this.renderChart = true;
            let myChart = this.$echarts.init(this.$refs.myChart);
            let child = this.child;
            let unit = this.unit
            // let color = ['#01CEFB', '#333333','#00E7C0', '#0065C0', '#1D3C70', '#7a65f2' ];
            let color = ['#B6E571', '#7EE48F','#00E7C0', '#01CEFB', '#018BFF', '#0065C0', '#1D3C70', '#6A40AE','#873476', '#DE3E5B', '#EB8B64', '#F9B67F',];
            let option = {
                color: color,
                title : {
                    text: this.title,
                    x: 'center'
                },
                grid: {
                    bottom: 100
                },
                tooltip : {
                    trigger: 'axis',
                    formatter:function (params,ticket,callback) {
                        let res = params[0].axisValue;
                        for (let i = 0; i < params.length; i++) {
                            res += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value + unit[i];
                        }
                        return res
                     }
                },
                calculable : true,
                legend: {
                    data: this.legend,
                    // y: 'bottom',
                    bottom: 10
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        data : this.xdata,
                        axisTick: {
                            show: false
                        },
                        splitLine: {show: false},
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        name : '单位: '+this.unit[0]+'               ',
                        nameLocation: 'end',
                        position: 'left',
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#999',
                                width: 1
                            }
                        },
                        axisLabel : {
                            formatter: function (params) {
                                return params;
                            }
                        }
                    },
                    {
                        type : 'value',
                        // name : '累计增长',
                        // 分割线
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel : {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: this.chartData,
            };
            myChart.setOption(option,true);
        },
        // 导出数据
        exportFn() {
            let _this = this;
            if (_this.starttime == '' || _this.endtime == '') {
                _this.$alert('请选择时间范围', '提示', {
                    confirmButtonText: '确定',
                });
                return;
            }
            exportFn({
                resourceId: _this.selectMenu.resourceId,
                pd: _this.selectMenu.pd,
                areaCode: _this.selectMenu.areaId,
                isShowNull: '1',
                dbxDm: 'zbdbx',
                majorPremeter: _this.option,
                dictionaryDm: "xsqx",
                starttime: _this.starttime,
                endtime: _this.endtime, 
                pubResourceId: _this.selectMenu.pubResourceId,
                /* starttime: _this.getTime(_this.startDate),
                endtime: _this.getTime(_this.endDate),  */
                resourceName: _this.selectMenu.resName
            }).then(res=>{
                let blob = new Blob([res], {
                    type: 'application/vnd.ms-excel'
                });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = _this.selectMenu.resName;
                link.click();
                window.URL.revokeObjectURL(link.href);
            })
        },
        // canvas图片下载保存到本地
        downloadFn() {
            let _this = this;
            let canvas = document.querySelector('#myChart').querySelector('canvas');
            let imgSrc = canvas.toDataURL('jpg');
            let elem = document.createElement('a');
            elem.setAttribute('href', imgSrc);
            elem.setAttribute('download', _this.selectMenu.resName);
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/public.scss';

.dataQuery{
    clear: both;
    display: flex;
    .menu{
        width: 200px;
        height: 1195px;
        // height: 100%;
        background: #fff;
        margin-right: 20px;
        display: inline-block;
        .firstMenu{
            width: 100%;
            height: 40px;
            font-size: 16px;
            a{
                width: 50%;
                text-align: center;
                line-height: 40px;
                font-weight: bold;
                margin: 0;
                float: left;
                &:hover{
                    cursor: pointer;
                }
                span{
                    font-size: 16px;
                    display: inline-block;
                    height: 100%;
                }
            }
            .tabOn{
                border-bottom: 2px solid #0067FF;
            }
            .el-menu{
                background: #fff;
            }
        }
        .secondMenu{
            width: 100%;
            clear: both;
            border: none;
            overflow: visible;
        }
    }
    .charts{
        width: 780px;
        display: inline-block;
        background: #fff;
        position: relative;
        .indicatorBreadcrumb{
            width: 100%;
            height: 40px;
            padding: 0 20px;
            box-sizing: border-box;
            line-height: 40px;
            p{
                margin: 0;
            }
        }
        .search{
            margin: 0 20px 15px 20px;
            padding: 15px 0;
            box-sizing: border-box;
            border-bottom: 1px solid #ccc;
            .time{
                float: right;
                .el-date-editor.el-input, .el-date-editor.el-input__inner{
                    width: 140px;
                }
                .searchImg{
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                    margin-left: 4px;
                }
            }
        }
        .myChart{
            width: 760px;
            height: 430px;
            // padding: 10px 20px;
            box-sizing: border-box;
            display: inline-block;
        }
        .tableData{
            width: 100%;
            height: 400px;
            margin-bottom: 30px;
            padding: 0 20px 20px 20px;
            box-sizing: border-box;
        }
        .fniconlist{
            position: absolute;
            top: 125px;
            right: 50px;
            float: right;
            .marginS{
                margin-right: 10px;
                overflow: hidden;
            }
            .downloadImg{
                width: 18px;
                height: 18px;
                vertical-align: -22%;
            }
        }
        .indirContent{
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            font-size: 16px;
            color: #333;
            line-height: 2;
            .title{
                border-bottom: 1px dashed #7c7c7c;
            }
            .content{
                text-indent: 2em;
                color: #777;
                padding-top: 5px;
                font-size: 13px;
                line-height: 1.5;
                height: 150px;
                text-indent: 2em
            }
        }
        
    }
    .report-list{
                width: 780px;
                height: 620px;
                background-color: #fff;
                .typename{
                    width: 760px;
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    display: inline-block;
                    font-size: 14px;
                    /* float: left; */
                    background-color: #E4EFF5;
                }
                ul{
                    margin: 0 20px;
                    margin-top: 10px;
                    padding: 0;
                    li{
                        height: 50px;
                        line-height: 50px;
                        font-size: 14px;
                        border-bottom: 1px dashed #ccc;
                        a{
                            height: 23px;
                            line-height: 23px;
                            float: left;
                            border-bottom: 1px solid #fff;
                            font-size: 14px;
                            cursor: pointer;
                            margin-top: 5px;
                            font-weight:bold;
                        }
                        span{
                            width: 100%;
                            height: 23px;
                            line-height: 23px;
                            float: left;
                            font-size: 12px;
                            color: #B9B9B9;
                            font-size: 12px;
                        }
                        a:hover{
                            border-bottom: 1px solid #ccc;
                        }
                    }
                }
                .num-style{
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    text-align: right;
                    margin-top: 10px;
                    
                    span{
                            width: 30px;
                            height: 30px;
                            background-color:#129ace;
                            display: inline-block;
                            text-align: center;
                            line-height: 30px;
                            font-size: 14px;
                            color: #fff;
                            cursor: pointer;
                            border-radius: 3px;
                            margin: 0 5px;
                    }
                }
            }
}
.foot{
      width: 100%;
      height: 140px;
      background: linear-gradient(360deg,rgba(37,122,214,1) 0%,rgba(93,175,244,1) 100%);
      margin-top: 50px;
      span:nth-child(1){
          margin-top: 35px;
      }
      span{
        height: 35px;
        width: 100%;
        text-align: center;
        line-height: 35px;
        font-size: 14px;
        float: left;
        color: #fff;
      }
    }
</style>

<style>
.secondMenu .el-menu-item, .el-submenu__title{
    height: 36px !important;
    line-height: 36px !important;
}
.secondMenu .el-menu--inline span{
    font-size: 14px;
}
.secondMenu li{
    white-space: nowrap; 
    overflow: hidden;
    text-overflow:ellipsis;
}
.tableData .el-table,
.tableData .el-table thead,
.tableData .el-table thead.is-group th{
    color: #333;
    background: #fff;
}
.tableData .el-menu-item:focus,.el-menu-item:hover,
.tableData .el-submenu__title:focus,.el-submenu__title:hover{
    outline:0;
    background-color:#c0d9f2;
}
.breadcrumb .el-breadcrumb__item span,
.indicatorBreadcrumb .el-breadcrumb__item span{
    margin: 0 2px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/dataReport/dataReport.vue